import { RadioGroup } from '@headlessui/react';
import React from 'react';
import ChoiceCard, { ChoiceCardProps } from '../ChoiceCard';
import { useToggle } from '../../../context/ToggleGroupContext';
import styled from 'styled-components';
import classnames from 'classnames';
import { palette } from '../../../theme/colors';
import { BASE_RADIUS } from '../../../theme/box';

export type ChoiceCardRadioProps = {
  value: string;
} & ChoiceCardProps;

const StyledContainer = styled.div`
  &.active {
    box-shadow: ${`0 0 0 1px ${palette.gray[600]}`};
    border-radius: ${`${BASE_RADIUS}px`};
  }, 
  :focus {
     outline: none;
   },
`;

const ChoiceCardRadioOption = ({
  value,
  title,
  disabled: forceDisabled,
  ...props
}: ChoiceCardRadioProps) => {
  const { disabled: stateDisabled } = useToggle();
  const disabled = forceDisabled || stateDisabled;

  return (
    <RadioGroup.Option
      className={({ active, checked }) =>
        classnames({ active, checked, disabled })
      }
      value={value}
      disabled={disabled}
      as={StyledContainer}
    >
      {({ checked }) => (
        <ChoiceCard
          title={title}
          selected={checked}
          disabled={disabled}
          type="button"
          {...props}
        />
      )}
    </RadioGroup.Option>
  );
};

ChoiceCardRadioOption.displayName = 'ChoiceCardRadioOption';
export default ChoiceCardRadioOption;
